import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import { UpdateRegion, UpdateRegionVariables } from '../../athena/types/UpdateRegion';
import { REGION_FIELDS } from '../../fragments/fence/region';

export const UPDATE_REGION = gql`
  mutation UpdateRegion($identifier: String, $tagIdentifiers: [String!], $postalCodes: [String!]) {
    fence {
      updateRegion(
        input: {
          region: {
            identifier: $identifier
            tagIdentifiers: $tagIdentifiers
            details: { postalCodes: $postalCodes }
          }
        }
      ) {
        region {
          ...RegionFields
        }
      }
    }
  }
  ${REGION_FIELDS}
`;

export const useUpdateRegion = () => {
  return useMutation<UpdateRegion, UpdateRegionVariables>(UPDATE_REGION);
};
